/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';

import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Maintenance from './components/Maintenance';
import Report from './components/Report';
import Landing from './components/Landing/Landing';
import Certificates from './components/Certificates';
import CertificateCheck from './components/CertificateCheck';
import ReportCheck from './components/ReportCheck';
import FormCertificates from './components/FormCertificates';
import TransportCertificates from './components/TransportCertificates';
import Users from './components/Users';
import FormUsers from './components/FormUsers';
import User from './components/User';
import AssetsProducing from './components/AssetsProducing';
import AssetsProducingArchived from './components/AssetsProducingArchived';
import AssetsConsuming from './components/AssetsConsuming';
import AssetsConsumingArchived from './components/AssetsConsumingArchived';
import AssetProducing from './components/AssetProducing';
import AssetConsuming from './components/AssetConsuming/AssetConsuming';
import FormAssetsProducing from './components/FormAssetsProducing';
import FormAssetsConsuming from './components/FormAssetsConsuming';
import Organization from './components/Organization/Organization';
import OrganizationList from './components/Organization/OrganizationList';
import Preferences from './components/Organization/OrganizationPreferences';
import OrganizationUsersList from './components/Organization/OrganizationUsersList';
import OrganizationAssetsConsumingList from './components/Organization/OrganizationAssetsConsumingList';
import OrganizationAssetsProducingList from './components/Organization/OrganizationAssetsProducingList';

import OrganizationForm from './components/Organization/OrganizationForm';
import Unauthorized from './components/Unauthorized';
import AuthCallback from './components/AuthCallback';

import { withStyles } from 'material-ui/styles';

import { CircularProgress } from 'material-ui/Progress';
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Favorite from 'material-ui-icons/Favorite';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import Hidden from 'material-ui/Hidden';
import Avatar from 'material-ui/Avatar';

import Dialog from 'material-ui/Dialog/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogTitle from 'material-ui/Dialog/DialogTitle';

import red from 'material-ui/colors/red';
import orange from 'material-ui/colors/orange';
import green from 'material-ui/colors/green';
import blue from 'material-ui/colors/blue';

import MenuIcon from 'material-ui-icons/Menu';

import factoryIcon from './assets/images/icon-map-factory-cotton.png';
import truckIcon from './assets/images/icons/truck.png';
import certificateIcon from './assets/images/icons/certificate.png';
import worldIcon from './assets/images/icons/world1.png';
import windTurbinesIcon from './assets/images/icons/wind-turbines.png';
import logoutIcon from './assets/images/icons/logout.png';
import mailIcon from './assets/images/icons/mail.png';
import wrenchIcon from './assets/images/icons/wrench.png';
import settingsIcon from './assets/images/icons/settings.png';
import usersIcon from './assets/images/icons/user-groups.png';
import gearsIcon from './assets/images/icons/gears.png';
import transactionListIcon from './assets/images/icons/transaction-list.png';
import organizationsIcon from './assets/images/icons/company.png';
import statisticsIcon from './assets/images/icons/statistics.png';

import Menu from 'material-ui/Menu/Menu';
import MenuItem from 'material-ui/Menu/MenuItem';
import ReactCountryFlag from 'react-country-flag';

import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';
import CloseIcon from 'material-ui-icons/Close';

import { enums } from './enums/';
import { constants } from './constants';
import {
  checkUserIsAdmin,
  checkUserIsSuperAdmin,
} from './utils/user/checkAdmin/CheckAdmin';
import { getUserDbId } from './utils/user/info';
import './App.css';
import './assets/fonts/Inter/Inter-Regular.ttf';
import './assets/fonts/Inter/Inter-SemiBold.ttf';

import {
  BrowserRouter as Router,
  Route,
  withRouter,
  NavLink,
  Redirect,
} from 'react-router-dom';
import {
  closeError,
  closeSuccess,
  closeInfo,
  openError,
  openSuccess,
  openInfo,
  checkAuthentication,
  logoutStart,
  getCurrentUser,
  isAuthenticatedAuth0,
} from './actions';
import BackgroundImage from './assets/images/background-american-public-power-association-unsplash.jpg';

import teoLogoBlue from './assets/images/teoLogoBleu.png';

import { translate, Trans } from 'react-i18next';
const unknownUserLogo = require('./assets/images/icons/default-user-avatar.png');
const unknownOrganizationLogo = require('./assets/images/teoLogoBleu.png');

const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: '90vh',
  },
  snackbarError: {
    backgroundColor: red[400],
    color: 'white',
  },
  snackbarWarning: {
    backgroundColor: orange[500],
    color: 'white',
  },
  snackbarSuccess: {
    backgroundColor: green[600],
    color: 'white',
  },
  snackbarInfo: {
    backgroundColor: blue[500],
    color: 'white',
  },
  listItemText: {
    fontSize: '0.8rem',
  },
  appBar: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.54)',
    zIndex: theme.zIndex.drawer + 1,
    position: 'absolute',
    [theme.breakpoints.up('md')]: {},
  },
  appBarLanding: {
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.54)',
    boxShadow: 'none',
    position: 'absolute',
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    position: 'relative',
    borderRight: 0,
    height: '100%',
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  headline: {
    fontSize: '1rem',
  },
});

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return rest.props.isAuthenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        );
      }}
    />
  );
};

class App extends React.Component {
  state = {
    mobileOpen: false,
    dialogMethodOpen: false,
    dialogContactOpen: false,
  };

  componentDidMount = async () => {
    const {
      checkAuthentication,
      history,
      cookies,
      isAuthenticatedAuth0,
      isAuthenticated,
    } = this.props;

    await checkAuthentication(history, cookies);
  };

  handleClickContactOpen = () => {
    this.setState({ dialogContactOpen: true });
  };

  handleContactClose = () => {
    this.setState({ dialogContactOpen: false });
  };

  handleClickMethodOpen = () => {
    this.setState({ dialogMethodOpen: true });
  };

  handleMethodClose = () => {
    this.setState({ dialogMethodOpen: false });
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.closeError();
  };

  handleCloseSuccess = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.closeError();
  };

  handleCloseInfo = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.closeInfo();
  };

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuContactClick = event => {
    this.setState({ anchorElContact: event.currentTarget });
  };

  handleMenuContactClose = () => {
    this.setState({ anchorElContact: null });
  };

  handleButtonCheckCertificate = () => {
    this.props.history.push('/certificates/check');
  };
  handleButtonCheckFile = () => {
    this.props.history.push('/reports/check');
  };

  changeLanguage = lng => {
    this.props.i18n.changeLanguage(lng);
    this.handleMenuClose();
  };

  renderAppBar() {
    const { anchorEl, anchorElContact } = this.state;
    const {
      classes,
      theme,
      error,
      isAuthenticated,
      username,
      t,
      user,
    } = this.props;
    if (!isAuthenticated) {
      return (
        <AppBar className={classes.appBarLanding}>
          <Toolbar>
            <div style={{ position: 'absolute', right: 10 }}>
              <Button
                color="inherit"
                onClick={() => this.handleButtonCheckCertificate()}
              >
                {t('Check certificate')}
              </Button>
              <Button
                color="inherit"
                onClick={() => this.handleButtonCheckFile()}
              >
                {t('Check report')}
              </Button>
              <Button
                aria-owns={anchorElContact ? 'contact-menu' : null}
                aria-haspopup="true"
                onClick={this.handleMenuContactClick}
                color="inherit"
              >
                Contact
              </Button>
              <Menu
                id="contact-menu"
                anchorEl={anchorElContact}
                open={Boolean(anchorElContact)}
                onClose={this.handleMenuContactClose}
              >
                <MenuItem>contact@attributes.digital</MenuItem>
              </Menu>
              <IconButton
                aria-owns={anchorEl ? 'language-menu' : null}
                aria-haspopup="true"
                onClick={this.handleMenuClick}
                color="inherit"
              >
                <img src={worldIcon} style={{ maxHeight: 20 }} />
              </IconButton>
              <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleMenuClose}
              >
                <MenuItem onClick={() => this.changeLanguage('fr')}>
                  <ReactCountryFlag code="FR" />
                </MenuItem>
                <MenuItem onClick={() => this.changeLanguage('en')}>
                  <ReactCountryFlag code="GB" />
                </MenuItem>
                <MenuItem onClick={() => this.changeLanguage('en_us')}>
                  <ReactCountryFlag code="US" />
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      );
    }

    let userLogo = user.user_metadata.pictureFileName
      ? process.env.REACT_APP_API_URL +
        '/static/users/' +
        user.user_metadata.pictureFileName
      : unknownUserLogo;

    let userId = getUserDbId(user);

    let isSuperAdmin = false;
    let isAdmin = false;
    if (checkUserIsAdmin(isAuthenticated, user)) isAdmin = true;
    if (checkUserIsSuperAdmin(isAuthenticated, user)) isSuperAdmin = true;
    let companyLogo = unknownOrganizationLogo;

    if (isSuperAdmin) {
      companyLogo =
        user.user_metadata.organization &&
        user.user_metadata.organization.pictureFileName
          ? process.env.REACT_APP_API_URL +
            '/static/organizations/' +
            user.user_metadata.organization.pictureFileName
          : unknownOrganizationLogo;
    } else if (isAdmin) {
      companyLogo =
        user.user_metadata.organization &&
        user.user_metadata.organization.pictureFileName
          ? process.env.REACT_APP_API_URL +
            '/static/organizations/' +
            user.user_metadata.organization.pictureFileName
          : unknownOrganizationLogo;
    } else {
      companyLogo =
        user.user_metadata.organization &&
        user.user_metadata.organization.parentOrganization &&
        user.user_metadata.organization.parentOrganization.pictureFileName
          ? process.env.REACT_APP_API_URL +
            '/static/organizations/' +
            user.user_metadata.organization.parentOrganization.pictureFileName
          : unknownOrganizationLogo;
    }

    return (
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            onClick={this.handleDrawerToggle}
            className={classes.navIconHide}
          >
            <MenuIcon />
          </IconButton>
          <div style={{ position: 'absolute', left: 62 }}>
            <img
              src={companyLogo}
              style={{ maxHeight: 70 }}
              onError={e => {
                e.target.onerror = null;
                e.target.src = unknownOrganizationLogo;
              }}
            />
          </div>
          <div style={{ position: 'absolute', right: 60 }}>
            <NavLink
              to={'/users/read/' + userId}
              style={{ textDecoration: 'none' }}
            >
              <Avatar
                src={userLogo}
                style={{ border: '1px solid rgba(0, 0, 0, 0.54)' }}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = unknownUserLogo;
                }}
              />
            </NavLink>
          </div>
          <div style={{ position: 'absolute', right: 10 }}>
            <IconButton
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleMenuClick}
              color="inherit"
            >
              <img src={worldIcon} style={{ maxHeight: 20 }} />
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleMenuClose}
            >
              <MenuItem onClick={() => this.changeLanguage('fr')}>
                <ReactCountryFlag code="FR" />
              </MenuItem>
              <MenuItem onClick={() => this.changeLanguage('en')}>
                <ReactCountryFlag code="GB" />
              </MenuItem>
              <MenuItem onClick={() => this.changeLanguage('en_us')}>
                <ReactCountryFlag code="US" />
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }

  renderDrawer() {
    const {
      classes,
      theme,
      error,
      isAuthenticated,
      user,
      username,
      history,
      t,
      i18n,
      cookies,
    } = this.props;
    if (!isAuthenticated) return false;

    let userLogo = user.user_metadata.pictureFileName
      ? process.env.REACT_APP_API_URL +
        '/static/users/' +
        user.user_metadata.pictureFileName
      : unknownUserLogo;

    let isSuperAdmin = false;
    let isAdmin = false;
    if (checkUserIsAdmin(isAuthenticated, user)) isAdmin = true;
    if (checkUserIsSuperAdmin(isAuthenticated, user)) isSuperAdmin = true;

    let companyLogo =
      user.user_metadata.organization &&
      user.user_metadata.organization.parentOrganization &&
      user.user_metadata.organization.parentOrganization.pictureFileName
        ? process.env.REACT_APP_API_URL +
          '/static/organizations/' +
          user.user_metadata.organization.parentOrganization.pictureFileName
        : teoLogoBlue;

    if (isSuperAdmin) {
      companyLogo = teoLogoBlue;
    } else if (isAdmin) {
      companyLogo =
        user.user_metadata.organization &&
        user.user_metadata.organization.pictureFileName
          ? process.env.REACT_APP_API_URL +
            '/static/organizations/' +
            user.user_metadata.organization.pictureFileName
          : teoLogoBlue;
    } else {
      companyLogo =
        user.user_metadata.organization &&
        user.user_metadata.organization.parentOrganization &&
        user.user_metadata.organization.parentOrganization.pictureFileName
          ? process.env.REACT_APP_API_URL +
            '/static/organizations/' +
            user.user_metadata.organization.parentOrganization.pictureFileName
          : teoLogoBlue;
    }

    let drawer = <div />;

    if (user.roles.includes(enums.UserRole.SUPER_ADMIN)) {
      drawer = (
        <div>
          <div
            className={classes.toolbar}
            style={{ padding: 10, maxHeight: 68, minHeight: 54 }}
          >
            <img
              src={companyLogo}
              style={{
                maxHeight: 70,
                float: 'left',
                position: 'absolute',
                top: 5,
                left: 36,
              }}
            />
            <CloseIcon
              style={{ float: 'right', margin: 20, cursor: 'pointer' }}
              onClick={this.handleDrawerToggle}
            />
          </div>
          <List>
            <NavLink to="/organizations" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={organizationsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Organizations')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/maintenance" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={gearsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Maintenance')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/report" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={transactionListIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production report')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/users" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={usersIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Users')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/cons" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={factoryIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Consumption assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/prod" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={windTurbinesIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/certificates" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={certificateIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Certificates')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink
              to="/transport_certificates"
              style={{ textDecoration: 'none' }}
              hidden={true}
            >
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={truckIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Customer deliveries')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.props.logoutStart(cookies);
              }}
            >
              <ListItemIcon>
                <img src={logoutIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Logout')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      );
    } else if (user.roles.includes(enums.UserRole.ADMIN)) {
      drawer = (
        <div>
          <div
            className={classes.toolbar}
            style={{ padding: 10, maxHeight: 68, minHeight: 54 }}
          >
            <img
              src={companyLogo}
              style={{
                maxHeight: 70,
                float: 'left',
                position: 'absolute',
                top: 5,
                left: 36,
              }}
            />
            <CloseIcon
              style={{ float: 'right', margin: 20, cursor: 'pointer' }}
              onClick={this.handleDrawerToggle}
            />
          </div>
          <List>
            <NavLink to="/dashboard" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={statisticsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Dashboard')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/users" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={usersIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Users')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/report" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={transactionListIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production report')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/organizations" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={organizationsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Organizations')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/cons" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={factoryIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Consumption assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/prod" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={windTurbinesIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/certificates" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={certificateIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Certificates')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink
              to="/transport_certificates"
              style={{ textDecoration: 'none' }}
              hidden={true}
            >
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={truckIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Customer deliveries')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.props.logoutStart(cookies);
              }}
            >
              <ListItemIcon>
                <img src={logoutIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Logout')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      );
    } else if (
      user.roles.includes('customer') &&
      user.roles.includes('hasDeliveries')
    ) {
      drawer = (
        <div>
          <div
            className={classes.toolbar}
            style={{
              textAlign: 'center',
              padding: 10,
              maxHeight: 44,
              minHeight: 44,
            }}
          >
            <img src={userLogo} style={{ maxHeight: 40 }} />
            <CloseIcon
              style={{ float: 'right', margin: 20, cursor: 'pointer' }}
              onClick={this.handleDrawerToggle}
            />
          </div>
          <List>
            <NavLink to="/dashboard" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={statisticsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Dashboard')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/cons" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={factoryIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <span />
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Consumption assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/prod" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={windTurbinesIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/certificates" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={certificateIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Certificates')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink
              to="/transport_certificates"
              style={{ textDecoration: 'none' }}
              hidden={true}
            >
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={truckIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Customer deliveries')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.props.logoutStart(cookies);
              }}
            >
              <ListItemIcon>
                <img src={logoutIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Logout')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      );
    } else if (user.roles.includes('customer')) {
      drawer = (
        <div>
          <div
            className={classes.toolbar}
            style={{ padding: 10, maxHeight: 68, minHeight: 54 }}
          >
            <img
              src={companyLogo}
              style={{
                maxHeight: 70,
                float: 'left',
                position: 'absolute',
                top: 5,
                left: 36,
              }}
            />
            <CloseIcon
              style={{ float: 'right', margin: 20, cursor: 'pointer' }}
              onClick={this.handleDrawerToggle}
            />
          </div>
          <List>
            <NavLink to="/dashboard" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={statisticsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Dashboard')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/cons" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={factoryIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Consumption assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/assets/prod" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={windTurbinesIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <NavLink to="/certificates" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={certificateIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Certificates')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.props.logoutStart(cookies);
              }}
            >
              <ListItemIcon>
                <img src={logoutIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Logout')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      );
    } else if (user.roles.includes('customerOfCustomer')) {
      drawer = (
        <div>
          <div
            className={classes.toolbar}
            style={{ padding: 10, maxHeight: 68, minHeight: 54 }}
          >
            <img
              src={companyLogo}
              style={{
                maxHeight: 70,
                float: 'left',
                position: 'absolute',
                top: 5,
                left: 36,
              }}
            />
          </div>
          <List>
            <NavLink to="/assets/prod" style={{ textDecoration: 'none' }}>
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={windTurbinesIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Production assets')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <a
              href="https://apdirect.airproducts.com/APDirect/Customer.aspx"
              target="_blank"
              onClick={this.handleDrawerToggle}
              style={{ textDecoration: 'none' }}
            >
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={settingsIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('MyAirProducts')}
                    </Typography>
                  }
                />
              </ListItem>
            </a>
            <NavLink
              to="/transport_certificates"
              style={{ textDecoration: 'none' }}
            >
              <ListItem button onClick={this.handleDrawerToggle}>
                <ListItemIcon>
                  <img src={truckIcon} style={{ maxHeight: 20 }} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography type="body2" className={classes.listItemText}>
                      {t('Deliveries')}
                    </Typography>
                  }
                />
              </ListItem>
            </NavLink>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.handleClickMethodOpen();
              }}
            >
              <ListItemIcon>
                <img src={wrenchIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Method')}
                  </Typography>
                }
              />
            </ListItem>
            <Dialog
              fullScreen={false}
              open={this.state.dialogMethodOpen}
              onClose={this.handleMethodClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title">Method</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <p>
                    For each delivery, we have two kinds of CO<sub>2</sub>{' '}
                    emissions : CO<sub>2</sub> related to the transport (CO
                    <sub>2</sub>Transport) and CO<sub>2</sub> related to the
                    energy consumed to produce the delivery volume of gas (CO
                    <sub>2</sub>Production). We display the sum CO<sub>2</sub>
                    Transport + CO<sub>2</sub>Production
                  </p>
                  <Typography variant="body2" gutterBottom>
                    CO<sub>2</sub>Transport
                  </Typography>
                  <p>
                    According to the distance from the gas production site and
                    the vehicule, we set the quantity of CO<sub>2</sub>{' '}
                  </p>
                  <Typography variant="body2" gutterBottom>
                    CO<sub>2</sub>Production
                  </Typography>
                  <p>
                    <ul>
                      <li>
                        Retrieve the average CO<sub>2</sub> emissions for a day
                        CO<sub>2</sub>DataDay (g of CO<sub>2</sub> /kWh) from{' '}
                        <a
                          href="https://www.rte-france.com/fr/eco2mix/eco2mix-co2"
                          target="_blank"
                        >
                          Eco2Mix
                        </a>{' '}
                      </li>
                      <li>
                        Retrieve all the deliveries of the day D
                        totalDeliveriesDay
                      </li>
                      <li>
                        Retrieve all the renewable energy used by Air Products
                        to produced the gas day D energyRenewableDay
                      </li>
                      <li>
                        Retrieve all the energy from the energy mix used by Air
                        Products to produced the gas day D energyMixDay
                      </li>
                      <li>
                        For each delivery, deliveryRatio = deliveryVolume /
                        totalDeliveriesDay
                      </li>
                      <li>
                        Then CO<sub>2</sub>Production =
                        deliveryRatio*energyMixDay*CO<sub>2</sub>DataDay
                      </li>
                      <li>
                        And CO<sub>2</sub>SavedDelivery =
                        deliveryRatio*energyRenewableDay*CO<sub>2</sub>DataDay
                      </li>
                    </ul>
                  </p>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleMethodClose}
                  color="primary"
                  autoFocus
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.handleClickContactOpen();
              }}
            >
              <ListItemIcon>
                <img src={mailIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Contact')}
                  </Typography>
                }
              />
            </ListItem>
            <Dialog
              fullScreen={false}
              open={this.state.dialogContactOpen}
              onClose={this.handleContactClose}
              aria-labelledby="responsive-dialog-title-contact"
            >
              <DialogTitle id="responsive-dialog-title-contact">
                Contact
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  You can reach Air Products here :{' '}
                  <a href="mailto:frcsomaj@airproducts.com" target="_blank">
                    frcsomaj@airproducts.com
                  </a>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleContactClose}
                  color="primary"
                  autoFocus
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
            <ListItem
              button
              onClick={() => {
                this.handleDrawerToggle();
                this.props.logoutStart(cookies);
              }}
            >
              <ListItemIcon>
                <img src={logoutIcon} style={{ maxHeight: 20 }} />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography type="body2" className={classes.listItemText}>
                    {t('Logout')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      );
    }
    return (
      <div>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </div>
    );
  }

  renderSnackBar() {
    const {
      classes,
      theme,
      error,
      success,
      history,
      t,
      i18n,
      isAuthenticated,
      user,
    } = this.props;

    const errorMessage = (
      <span id="message-id">
        {this.props.error && this.props.error.message
          ? this.props.error.message
          : 'Error'}
      </span>
    );

    const successMessage = (
      <span id="message-id">
        {this.props.success && this.props.success.message
          ? this.props.success.message
          : 'Success'}
      </span>
    );

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.props.error.isVisible}
          autoHideDuration={constants.TOAST_AUTO_HIDE_DURATION_IN_MS}
          onClose={() => {
            this.props.closeError();
          }}
          ContentProps={{
            'aria-describedby': 'message-id',
            className: classes.snackbarError,
          }}
          message={errorMessage}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={() => {
                this.props.closeError();
              }}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.props.success.isVisible}
          autoHideDuration={constants.TOAST_AUTO_HIDE_DURATION_IN_MS}
          onClose={() => {
            this.props.closeSuccess();
          }}
          ContentProps={{
            'aria-describedby': 'message-id',
            className: classes.snackbarSuccess,
          }}
          message={successMessage}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={() => {
                this.props.closeSuccess();
              }}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }

  renderFooter() {
    const {
      classes,
      theme,
      error,
      success,
      history,
      t,
      i18n,
      isAuthenticated,
      user,
      loadingCheck,
    } = this.props;

    const madeWithStyle = !isAuthenticated
      ? {
          flexDirection: 'row',
          justifyContent: 'center',
          flexWrap: 'nowrap',
          alignItems: 'center',
          alignContent: 'center',
          textAlign: 'center',
          width: '100%',
          position: 'absolute',
          bottom: 50,
          left: 0,
        }
      : {
          clear: 'both',
          flexDirection: 'row',
          justifyContent: 'center',
          flexWrap: 'nowrap',
          alignItems: 'center',
          alignContent: 'center',
          textAlign: 'center',
          paddingTop: 30,
          width: '100%',
          boxSizing: 'border-box',
          height: '10vh',
        };

    const madeWithTextStyle = !isAuthenticated
      ? {
          color: '#ffffff',
          marginBottom: 10,
        }
      : {
          color: '#8f8f8f',
          marginBottom: 10,
        };

    return (
      <footer style={madeWithStyle}>
        <Typography component="p" style={madeWithTextStyle}>
          {t('Made with')} <Favorite style={{ fontSize: 12 }} />{' '}
          {t('by') + ' Attributes'}
        </Typography>
        <Typography component="p" style={madeWithTextStyle}>
          {t('and certified on the Energy Web Foundation Blockchain')}
        </Typography>
      </footer>
    );
  }

  render() {
    const {
      classes,
      theme,
      error,
      success,
      history,
      t,
      i18n,
      isAuthenticated,
      user,
      loadingCheck,
    } = this.props;

    const imageBackgroundStyle = !isAuthenticated
      ? {
          backgroundImage: 'url(' + BackgroundImage + ')',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }
      : {};

    const mainStyle = !isAuthenticated
      ? {
          height: '100%',
          overflowX: 'auto',
          backgroundColor: 'transparent',
        }
      : {
          height: '100%',
          overflowX: 'auto',
        };
    if (loadingCheck) {
      return <CircularProgress size={24} />;
    }
    if (!isAuthenticated) {
      return (
        <div>
          {this.renderSnackBar()}
          <Route exact path="/" props={this.props} component={Landing} />
          <Route
            exact
            path="/get-user-on-authentication"
            props={this.props}
            component={AuthCallback}
          />
          <Route exact path="/consumer" props={this.props} component={Login} />
          <Route
            exact
            path="/unauthorized"
            props={this.props}
            component={Unauthorized}
          />
          <Route
            exact
            path="/certificates/check"
            props={this.props}
            component={CertificateCheck}
          />
          <Route
            exact
            path="/reports/check"
            props={this.props}
            component={ReportCheck}
          />
        </div>
      );
    }

    return (
      <div key={isAuthenticated} style={imageBackgroundStyle}>
        {this.renderSnackBar()}
        <div className={classes.root}>
          {this.renderAppBar()}
          {this.renderDrawer()}
          <main
            key={'main' + isAuthenticated}
            className={classes.content}
            style={mainStyle}
          >
            <div className={classes.toolbar} />

            <div>
              <Route
                exact
                path="/get-user-on-authentication"
                props={this.props}
                component={AuthCallback}
              />

              <Route
                exact
                path="/certificates/check"
                props={this.props}
                component={CertificateCheck}
              />
              <PrivateRoute
                exact
                path="/assets/prod"
                props={this.props}
                component={AssetsProducing}
              />
              <Route
                exact
                path="/reports/check"
                props={this.props}
                component={ReportCheck}
              />
              <PrivateRoute
                exact
                path="/assets/prod/archived"
                props={this.props}
                component={AssetsProducingArchived}
              />
              <PrivateRoute
                exact
                path="/preferences"
                props={this.props}
                component={Preferences}
              />
              <PrivateRoute
                exact
                path="/organizations"
                props={this.props}
                component={OrganizationList}
              />
              <PrivateRoute
                exact
                path="/organizations/create"
                props={this.props}
                component={OrganizationForm}
              />
              <PrivateRoute
                exact
                path="/organizations/update/:organizationId"
                props={this.props}
                component={OrganizationForm}
              />
              <PrivateRoute
                exact
                path="/organizations/read/:organizationId"
                props={this.props}
                component={Organization}
              />
              <PrivateRoute
                exact
                path="/organizations/read/:organizationId/users"
                props={this.props}
                component={OrganizationUsersList}
              />
              <PrivateRoute
                exact
                path="/organizations/read/:organizationId/consum"
                props={this.props}
                component={OrganizationAssetsConsumingList}
              />
              <PrivateRoute
                exact
                path="/organizations/read/:organizationId/prod"
                props={this.props}
                component={OrganizationAssetsProducingList}
              />
              <PrivateRoute
                exact
                path="/maintenance"
                props={this.props}
                component={Maintenance}
              />
              <PrivateRoute
                exact
                path="/report"
                props={this.props}
                component={Report}
              />
              <PrivateRoute
                exact
                path="/assets/prod/create"
                props={this.props}
                component={FormAssetsProducing}
              />
              <PrivateRoute
                exact
                path="/assets/prod/update/:assetId"
                props={this.props}
                component={FormAssetsProducing}
              />
              <PrivateRoute
                exact
                path="/assets/prod/read/:assetId"
                props={this.props}
                component={AssetProducing}
              />

              <PrivateRoute
                exact
                path="/dashboard"
                props={this.props}
                component={Dashboard}
              />

              <PrivateRoute
                exact
                path="/assets/cons"
                props={this.props}
                component={AssetsConsuming}
              />

              <PrivateRoute
                exact
                path="/assets/cons/archived"
                props={this.props}
                component={AssetsConsumingArchived}
              />

              <PrivateRoute
                exact
                path="/assets/cons/create"
                props={this.props}
                component={FormAssetsConsuming}
              />
              <PrivateRoute
                exact
                path="/assets/cons/update/:assetId"
                props={this.props}
                component={FormAssetsConsuming}
              />
              <PrivateRoute
                exact
                path="/assets/cons/read/:assetId"
                props={this.props}
                component={AssetConsuming}
              />

              <PrivateRoute
                exact
                path="/certificates"
                props={this.props}
                component={Certificates}
              />
              <PrivateRoute
                exact
                path="/certificates/create"
                props={this.props}
                component={FormCertificates}
              />

              <PrivateRoute
                exact
                path="/transport_certificates"
                props={this.props}
                component={TransportCertificates}
              />

              <PrivateRoute
                exact
                path="/users"
                props={this.props}
                component={Users}
              />
              <PrivateRoute
                exact
                path="/users/create"
                props={this.props}
                component={FormUsers}
              />
              <PrivateRoute
                exact
                path="/users/read/:userId"
                props={this.props}
                component={User}
              />
              <PrivateRoute
                exact
                path="/users/update/:userId"
                props={this.props}
                component={FormUsers}
              />
            </div>
          </main>
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ snackBarReducer, loginReducer }) => {
  const { error, success } = snackBarReducer;
  const { isAuthenticated, username, user, loadingCheck } = loginReducer;
  return { error, success, isAuthenticated, user, username, loadingCheck };
};

const mapDispatchToProps = {
  closeError,
  closeSuccess,
  closeInfo,
  openError,
  openSuccess,
  openInfo,
  checkAuthentication,
  logoutStart,
  getCurrentUser,
  isAuthenticatedAuth0,
};

App = withStyles(styles, { withTheme: true, name: 'App' })(App);
App = translate('translations')(App);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withCookies(App))
);



// WEBPACK FOOTER //
// ./src/App.js